import { connect } from 'react-redux';
import { firebase, helpers } from 'redux-react-firebase';
import Signup from '../../components/auth/signup';

const { pathToJS } = helpers;

const mapStateToProps = state => ({
  authError: pathToJS(state.firebase, 'authError'),
  auth: pathToJS(state.firebase, 'auth'),
});

export default firebase()(connect(mapStateToProps)(Signup));



// WEBPACK FOOTER //
// ./src/containers/auth/signup.js